"use client"

import { useState, useEffect, useRef, useCallback } from "react"
import {
  Modal,
  Container,
  Row,
  Col,
  Button,
  Card,
  Form,
  ProgressBar,
  Table,
  Pagination,
  Badge,
  InputGroup,
  Dropdown,
  DropdownButton,
  Alert,
  Spinner,
  Nav,
} from "react-bootstrap"
import {
  exportToExcel,
  exportToPDF,
  exportToCSV
} from "./utils/exportUtils"
import "bootstrap/dist/css/bootstrap.min.css"
import "../styles/style.css"
import NavBar from "./Navbar"
import Journals from "./journals"
import * as XLSX from "xlsx"
import axios from "axios"
import ReportsDashboard from "./reports-dashboard"
import { setupIndexedDB } from "../database/db"
import { jsPDF } from "jspdf"
import autoTable from "jspdf-autotable"

function PayrollPage({ user, onLogout }) {
  const API_BASE = "http://109.75.164.217:84/api"

  // Main application tab state
  const [activeMainTab, setActiveMainTab] = useState("search")

  // Search & payroll state
  const [selectedYear, setSelectedYear] = useState("")
  const [selectedGroup, setSelectedGroup] = useState("")
  const [selectedPeriod, setSelectedPeriod] = useState("")
  const [searchResult, setSearchResult] = useState(null)
  const [searching, setSearching] = useState(false)
  const [notFound, setNotFound] = useState(false)
  const [creating, setCreating] = useState(false)
  const [dataViewType, setDataViewType] = useState("payroll")

  // Selected employee for total calculation
  const [selectedEmployee, setSelectedEmployee] = useState(null)
  const [employeeTotal, setEmployeeTotal] = useState(0)

  // Employee totals map
  const [employeeTotals, setEmployeeTotals] = useState({})

  const [payrollData, setPayrollData] = useState([
    {
      year: "2024",
      group: "DCG",
      period: "Q1",
      payrollId: "P001",
      payrollAmount: "$5000",
      numberOfEmployees: 10,
      runStatus: "Completed",
      dateRun: "2024-01-15",
      runBy: "Admin",
    },
  ])
  const dataTabHeaders = [
    "employeeNo",
    "employeeName",
    "amount",
    "benefit",
    "total",
  ]

  // Create payroll modal state
  const [showCreatePayrollModal, setShowCreatePayrollModal] = useState(false)
  const [newPayrollData, setNewPayrollData] = useState({
    payrollId: "",
    description: "",
    accountingString: "",
  })

  // Data view search state
  const [dataViewYear, setDataViewYear] = useState("")
  const [dataViewGroup, setDataViewGroup] = useState("")
  const [dataViewPeriod, setDataViewPeriod] = useState("")
  const [dataViewPayrollId, setDataViewPayrollId] = useState("")
  const [dataSearching, setDataSearching] = useState(false)
  // Add new state for tracking file data status
const [fileDataStatus, setFileDataStatus] = useState(null)
const [checkingFileData, setCheckingFileData] = useState(false)

  // File upload & progress state
  const [fileUploads, setFileUploads] = useState({ payroll: null, timesheet: null })
  const [uploadProgress, setUploadProgress] = useState({ payroll: 0, timesheet: 0 })

  // Dynamic file types loaded from backend
  const [dynamicFileTypes, setDynamicFileTypes] = useState([])
  const [dynamicUploads, setDynamicUploads] = useState({})
  const [dynamicProgress, setDynamicProgress] = useState({})

  // Processing state & report
  const [processing, setProcessing] = useState(false)
  const [outputData, setOutputData] = useState([])
  const [errorData, setErrorData] = useState([])
  const [startTime, setStartTime] = useState("")
  const [finishTime, setFinishTime] = useState("")
  const [showProcessingReport, setShowProcessingReport] = useState(false)

  // Table & modal state
  const [tableData, setTableData] = useState([])
  const [loadingTableData, setLoadingTableData] = useState(false)
  const [showTableModal, setShowTableModal] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  // Reports state
  const [reportData, setReportData] = useState([])
  const [reportType, setReportType] = useState("pension")
  const [loadingReportData, setLoadingReportData] = useState(false)

  // Pension processing state
  const [pensionProcessing, setPensionProcessing] = useState(false)
  const [pensionProgress, setPensionProgress] = useState(0)
  const [pensionTotal, setPensionTotal] = useState(0)
  const [pensionCurrent, setPensionCurrent] = useState(0)
  const [pensionStatus, setPensionStatus] = useState("")
  const [showPensionButton, setShowPensionButton] = useState(false)
  const [processingErrors, setProcessingErrors] = useState([])

  // Calculated fields processing state
  const [calculatedProcessing, setCalculatedProcessing] = useState(false)
  const [calculatedProgress, setCalculatedProgress] = useState(0)
  const [calculatedTotal, setCalculatedTotal] = useState(0)
  const [calculatedCurrent, setCalculatedCurrent] = useState(0)
  const [calculatedStatus, setCalculatedStatus] = useState("")
  const [calculatedStartTime, setCalculatedStartTime] = useState("")
  const [calculatedFinishTime, setCalculatedFinishTime] = useState("")
  const [calculatedErrors, setCalculatedErrors] = useState([])

  // Delete payroll state
  const [deleting, setDeleting] = useState(false)

  // Apportionment processing state
  const [apportionmentProcessing, setApportionmentProcessing] = useState(false)
  const [apportionmentStatus, setApportionmentStatus] = useState("")
  const [apportionmentStartTime, setApportionmentStartTime] = useState("")
  const [apportionmentFinishTime, setApportionmentFinishTime] = useState("")
  const [apportionmentErrors, setApportionmentErrors] = useState([])

  // Stepper state for workflow
  const [currentStep, setCurrentStep] = useState(1)

  // Refs for concurrent uploads
  const uploadPromises = useRef({})

  // Processing completion modal state
  const [showProcessingCompleteModal, setShowProcessingCompleteModal] = useState(false)
  const [processingResults, setProcessingResults] = useState({
    totalRecords: 0,
    processedRecords: 0,
    errors: [],
    processingTime: '',
    completedAt: ''
  })

  // Initialize IndexedDB when component mounts
  useEffect(() => {
    setupIndexedDB().catch((err) => {
      console.error("Failed to setup IndexedDB:", err)
      setOutputData((prev) => [...prev, `Error setting up IndexedDB: ${err.message}`])
    })
  }, [])

  // Get payroll ID based on current selections
  const getPayrollId = useCallback(() => {
    return `${selectedPeriod}_${selectedYear}_${selectedGroup}`
  }, [selectedPeriod, selectedYear, selectedGroup])

  // Calculate employee totals when table data changes
  useEffect(() => {
    if (tableData.length > 0) {
      const totals = {}

      // Group by employee and calculate totals
      tableData.forEach((row) => {
        const employeeNo = row.employeeNo
        if (!totals[employeeNo]) {
          totals[employeeNo] = {
            total: 0,
            name: row.employeeName,
          }
        }
        totals[employeeNo].total += Number.parseFloat(row.amount) || 0
      })

      setEmployeeTotals(totals)
    }
  }, [tableData])

  // Add function to check file data status
  const checkFileDataStatus = async (payrollId, group) => {
    if (!payrollId || !group) return
    
    try {
      setCheckingFileData(true)
      const { data } = await axios.get(`${API_BASE}/Apportionments/data/data/${payrollId}/${group}`)
      setFileDataStatus(data)
      return data
    } catch (error) {
      console.error("Error checking file data status:", error)
      setFileDataStatus(null)
    } finally {
      setCheckingFileData(false)
    }
  }

  // Function to check if processing can start (has data records)
 const canStartProcessing = () => {
  if (!fileDataStatus) return false
  
  // Required files that must have data before processing can start
  const requiredFiles = ['payroll', 'timesheet', 'airtime', 'accruedleave', 'masm']
  
  // Check if ALL required files have data records > 0
  const allRequiredFilesHaveData = requiredFiles.every(fileName => {
    return fileDataStatus.filesWithData?.some(file => 
      file.dataFile === fileName && file.recordsCount > 0
    )
  })
  
  return allRequiredFilesHaveData
}

  // Function to determine if uploads are needed
  const needsFileUploads = () => {
    // Always show uploads for new payrolls (no fileDataStatus)
    if (!fileDataStatus) {
      return true
    }
    
    // Required files that must have data - but only check the uploadable ones
    // We only show upload forms for files that can be uploaded (payroll, timesheet, and dynamic files)
    const uploadableFiles = ['payroll', 'timesheet']
    
    // Check each uploadable file
    for (const fileName of uploadableFiles) {
      let hasData = false
      
      // Check if file exists in filesWithData with records > 0
      if (fileDataStatus.filesWithData && Array.isArray(fileDataStatus.filesWithData)) {
        hasData = fileDataStatus.filesWithData.some(file => 
          file.dataFile === fileName && file.recordsCount > 0
        )
      }
      
      // If this uploadable file doesn't have data, uploads are needed
      if (!hasData) {
        return true
      }
    }
    
    // Also check if any dynamic files (additional files) are missing
    // This allows uploading missing dynamic files even if payroll/timesheet exist
    if (dynamicFileTypes && dynamicFileTypes.length > 0) {
      const hasMissingDynamicFiles = dynamicFileTypes.some(def => {
        const hasData = fileDataStatus.filesWithData?.some(file => 
          file.dataFile === def.dataName && file.recordsCount > 0
        )
        return !hasData
      })
      
      if (hasMissingDynamicFiles) {
        return true
      }
    }
    
    // Additional check: if we have filesWithoutData (files with 0 records), consider showing uploads
    // This catches cases where files exist in the system but have no data
    if (fileDataStatus.filesWithoutData && Array.isArray(fileDataStatus.filesWithoutData)) {
      const hasFilesWithoutData = fileDataStatus.filesWithoutData.some(file => 
        uploadableFiles.includes(file.dataFile) || 
        (dynamicFileTypes && dynamicFileTypes.some(def => def.dataName === file.dataFile))
      )
      
      if (hasFilesWithoutData) {
        return true
      }
    }
    
    // All uploadable files have data, no uploads needed
    return false
  }

  // Function to get list of missing files that need to be uploaded
  const getMissingFiles = () => {
    const missingFiles = []
    
    if (!fileDataStatus) {
      return ['payroll', 'timesheet'] // Default for new payrolls
    }
    
    const uploadableFiles = ['payroll', 'timesheet']
    
    // Check each uploadable file
    for (const fileName of uploadableFiles) {
      let hasData = false
      
      // Check if file exists in filesWithData with records > 0
      if (fileDataStatus.filesWithData && Array.isArray(fileDataStatus.filesWithData)) {
        hasData = fileDataStatus.filesWithData.some(file => 
          file.dataFile === fileName && file.recordsCount > 0
        )
      }
      
      if (!hasData) {
        missingFiles.push(fileName)
      }
    }
    
    // Check dynamic files
    if (dynamicFileTypes && dynamicFileTypes.length > 0) {
      dynamicFileTypes.forEach(def => {
        const hasData = fileDataStatus.filesWithData?.some(file => 
          file.dataFile === def.dataName && file.recordsCount > 0
        )
        if (!hasData) {
          missingFiles.push(def.dataName)
        }
      })
    }
    
    // Check filesWithoutData
    if (fileDataStatus.filesWithoutData && Array.isArray(fileDataStatus.filesWithoutData)) {
      fileDataStatus.filesWithoutData.forEach(file => {
        if (uploadableFiles.includes(file.dataFile) || 
            (dynamicFileTypes && dynamicFileTypes.some(def => def.dataName === file.dataFile))) {
          if (!missingFiles.includes(file.dataFile)) {
            missingFiles.push(file.dataFile)
          }
        }
      })
    }
    
    return missingFiles
  }

  // Function to check if any required missing files have been selected for upload
  const hasSelectedRequiredFiles = () => {
    const missingFiles = getMissingFiles()
    
    // Check if any missing file has been selected for upload
    return missingFiles.some(fileName => {
      if (fileName === 'payroll') return fileUploads.payroll
      if (fileName === 'timesheet') return fileUploads.timesheet
      // For dynamic files, check if they're in dynamicUploads
      return dynamicUploads && dynamicUploads[fileName]
    })
  }

  // Helpers
  const readFileAsArrayBuffer = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => resolve(e.target.result)
      reader.onerror = reject
      reader.readAsArrayBuffer(file)
    })

  const sendJsonData = async (url, payload) => {
    try {
      const resp = await axios.post(url, payload, {
        headers: { "Content-Type": "application/json" },
      })
      return resp.data
    } catch (error) {
      // Check if it's a 400 response with "action": "proceed"
      if (error.response && error.response.status === 400) {
        const responseData = error.response.data
        if (responseData && responseData.action === "proceed") {
          // Log the warning but don't throw an error
          const employeeInfo = payload.data && payload.data.length > 1
            ? `${payload.data[0]} (${payload.data[1]})`
            : "Unknown"
          const warningMsg = `Warning for employee ${employeeInfo}: ${responseData.message || error.message} - Continuing as instructed`
          setOutputData((p) => [...p, `⚠️ ${warningMsg}`])
          console.warn(warningMsg)
          return responseData // Return the response data instead of throwing
        }
      }

      // Enhanced error handling with employee info for actual errors
      if (payload.data && payload.data.length > 1) {
        const employeeNo = payload.data[0] || "Unknown"
        const employeeName = payload.data[1] || "Unknown"
        throw new Error(`Error for employee ${employeeNo} (${employeeName}): ${error.message}`)
      } else {
        throw error
      }
    }
  }

  const deleteOldData = async (url) => {
    const resp = await fetch(url, { method: "DELETE", headers: { "Content-Type": "application/json" } })
    if (!resp.ok) throw new Error(`Delete failed: ${resp.status}`)
  }

  const updateProgressBarForType = async (current, total, key) => {
    const pct = (current / total) * 100
    if (uploadProgress.hasOwnProperty(key)) {
      setUploadProgress((p) => ({ ...p, [key]: pct }))
    } else {
      setDynamicProgress((p) => ({ ...p, [key]: pct }))
    }
    await new Promise((r) => setTimeout(r, 10))
  }

  // Load dynamic file types - only those with typeOfData: "provided"
  const fetchDynamicFileTypes = async () => {
    try {
      const { data } = await axios.get(`${API_BASE}/inputdata/datafiles`)
      // Filter for active files, exclude payroll/timesheet, and only include "provided" types
      const dyn = data.filter((d) => 
        d.dataStatus === 1 && 
        !["payroll", "timesheet"].includes(d.dataName) &&
        d.typeOfData === "provided"
      )
      setDynamicFileTypes(dyn)
      const up = {},
        pr = {}
      dyn.forEach((d) => {
        up[d.fields] = null
        pr[d.fields] = 0
      })
      setDynamicUploads(up)
      setDynamicProgress(pr)
    } catch (err) {
      console.error("Error loading dynamic fields:", err)
    }
  }

  // Check if payroll exists
  const checkPayrollExists = async (payrollId, group) => {
    try {
      const url = `${API_BASE}/payrolls/${group}/${payrollId}`
      const response = await axios.get(url)
      return { exists: true, data: response.data }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return { exists: false }
      }
      throw error
    }
  }

  // Handle search for payroll
 const handleSearch = useCallback(async () => {
  if (!selectedYear || !selectedGroup || !selectedPeriod) return

  const payrollId = getPayrollId()

  setSearching(true)
  setNotFound(false)
  setSearchResult(null)
  setFileDataStatus(null)

  try {
    const { data } = await axios.get(`${API_BASE}/PayrollRuns/${payrollId}`)

    const result = {
      year: selectedYear,
      group: selectedGroup,
      period: selectedPeriod,
      payrollId: payrollId,
      payrollAmount: data.amount || "$0",
      numberOfEmployees: data.employeeCount || 0,
      runStatus: data.status || "Pending",
      dateRun: data.dateCreated || new Date().toISOString().split("T")[0],
      runBy: data.createdBy || user.username || "Current User",
      accountingString: data.accountingString || "Default",
      hasFiles: true,
    }

    setSearchResult(result)

    // Check file data status after finding payroll
    await checkFileDataStatus(payrollId, selectedGroup)
    await fetchDynamicFileTypes()

  } catch (err) {
    if (err.response?.status === 404) {
      setNotFound(true)
    } else {
      console.error(err)
    }
  } finally {
    setSearching(false)
  }
}, [selectedYear, selectedGroup, selectedPeriod, getPayrollId, user.username])

  // Create new payroll
  const handleCreatePayroll = async () => {
    try {
      setCreating(true)

      const payrollId = getPayrollId()

      const payload = {
        obj: "payroll",
        payrollId: payrollId,
        group: selectedGroup,
        period: `${selectedPeriod}_${selectedYear}`,
        filepath: "",
        sysUser: user.username || "sysuser",
      }

      // Create the payroll
      await axios.post(`${API_BASE}/PayrollRuns`, payload)

      // Build the result object
      const newPayroll = {
        year: selectedYear,
        group: selectedGroup,
        period: selectedPeriod,
        payrollId: payrollId,
        payrollAmount: "$0",
        numberOfEmployees: 0,
        runStatus: "Pending",
        dateRun: new Date().toISOString().split("T")[0],
        runBy: user.username || "Current User",
        accountingString: "",
        hasFiles: false, // New payroll doesn't have files yet
      }

      // Update state
      setPayrollData((prev) => [...prev, newPayroll])
      setSearchResult(newPayroll)
      setNotFound(false)

      // Load dynamic fields for upload
      await fetchDynamicFileTypes()

      return newPayroll
    } catch (error) {
      console.error("Error creating payroll:", error)
      alert(`Failed to create payroll: ${error.message}`)
      return null
    } finally {
      setCreating(false)
    }
  }

  // File processors - now returns promises for concurrent processing
  const processPayrollFile = async (file) => {
    try {
      const data = await readFileAsArrayBuffer(file)
      const wb = XLSX.read(data, { type: "array" })
      const ws = wb.Sheets[wb.SheetNames[0]]
      const json = XLSX.utils.sheet_to_json(ws, { header: 1 })
      const header = json[4]
      const run = {
        Obj: "payroll",
        RunPeriod: `${selectedPeriod}_${selectedYear}`,
        EmployeeGroup: selectedGroup,
        PayrollId: searchResult.payrollId,
        FilePath: file.name,
        accountingString: searchResult.accountingString || "Default",
        SysUser: user.username || "sysuser",
      }

      //await deleteOldData(`${API_BASE}/InputData/payroll/${run.EmployeeGroup}/${run.PayrollId}`)

      const errors = []
      for (let i = 6; i < json.length; i++) {
        try {
          await sendJsonData(`${API_BASE}/payrolls`, {
            data: json[i].map(String),
            header,
            run,
          })
        } catch (e) {
          const errorMsg = `Error payroll row ${i}: ${e.message}`
          errors.push(errorMsg)
          setOutputData((p) => [...p, errorMsg])
        }
        await updateProgressBarForType(i - 5, json.length - 6, "payroll")
      }

      return { type: "payroll", errors }
    } catch (error) {
      console.error("Error processing payroll file:", error)
      return { type: "payroll", errors: [`Failed to process payroll file: ${error.message}`] }
    }
  }

  const processTimesheetFile = async (file) => {
    try {
      const data = await readFileAsArrayBuffer(file)
      const wb = XLSX.read(data, { type: "array" })
      const ws = wb.Sheets[wb.SheetNames[0]]
      const json = XLSX.utils.sheet_to_json(ws, { header: 1 })
      const header = json[5]
      const run = {
        Obj: "timesheet",
        Period: `${selectedPeriod}_${selectedYear}`,
        EmployeeGroup: selectedGroup,
        PayrollId: searchResult.payrollId,
        FilePath: file.name,
        SysUser: user.username || "sysuser",
      }

  //  await deleteOldData(`${API_BASE}/InputData/Timesheets/${run.EmployeeGroup}/${run.PayrollId}`)

      const errors = []
      for (let i = 7; i < json.length; i++) {
        try {
          await sendJsonData(`${API_BASE}/Timesheets`, {
            data: json[i].map(String),
            header,
            run,
          })
        } catch (e) {
          const errorMsg = `Error timesheet row ${i}: ${e.message}`
          errors.push(errorMsg)
          setOutputData((p) => [...p, errorMsg])
        }
        await updateProgressBarForType(i - 6, json.length - 7, "timesheet")
      }

      return { type: "timesheet", errors }
    } catch (error) {
      console.error("Error processing timesheet file:", error)
      return { type: "timesheet", errors: [`Failed to process timesheet file: ${error.message}`] }
    }
  }

  const processDynamicFile = async (def, file) => {
    try {
      const data = await readFileAsArrayBuffer(file)
      const wb = XLSX.read(data, { type: "array" })
      const ws = wb.Sheets[wb.SheetNames[0]]
      const json = XLSX.utils.sheet_to_json(ws, { header: 1 })
      const header = json[0]
      const run = {
        Obj: def.dataName,
        Period: `${selectedPeriod}_${selectedYear}`,
        EmployeeGroup: selectedGroup,
        PayrollId: searchResult.payrollId,
        FilePath: file.name,
        SysUser: user.username || "sysuser",
      }

      await deleteOldData(`${API_BASE}/InputData/${def.dataName}/${run.EmployeeGroup}/${run.Period}`)

      const errors = []
      for (let i = 1; i < json.length; i++) {
        try {
          await sendJsonData(`${API_BASE}/ProcessData`, {
            data: json[i].map(String),
            header,
            run,
          })
        } catch (e) {
          const errorMsg = `Error ${def.dataName} row ${i}: ${e.message}`
          errors.push(errorMsg)
          setOutputData((p) => [...p, errorMsg])
        }
        await updateProgressBarForType(i, json.length - 1, def.fields)
      }

      return { type: def.dataName, errors }
    } catch (error) {
      console.error(`Error processing ${def.dataName} file:`, error)
      return { type: def.dataName, errors: [`Failed to process ${def.dataName} file: ${error.message}`] }
    }
  }

  // Handlers
  const handleFileSelect = (type, e) => setFileUploads((p) => ({ ...p, [type]: e.target.files[0] }))
  const handleDynamicFileSelect = (f, e) => setDynamicUploads((p) => ({ ...p, [f]: e.target.files[0] }))

  // Check if we can process data (all required files uploaded)
  const canProcessData = () => {
    // Check if fileDataStatus is available
    if (!fileDataStatus) return false
    
    // Check if all required files have data
    const requiredFiles = ['payroll', 'timesheet', 'airtime', 'accruedleave', 'masm']
    const allFilesHaveData = requiredFiles.every(fileName => {
      return fileDataStatus.filesWithData?.some(file => 
        file.dataFile === fileName && file.recordsCount > 0
      )
    })
    
    // Also check if any dynamic files are present (if any are defined)
    const dynamicFilesPresent = dynamicFileTypes.length === 0 || dynamicFileTypes.every(def => {
      return fileDataStatus.filesWithData?.some(file => 
        file.dataFile === def.dataName && file.recordsCount > 0
      )
    })
    
    return allFilesHaveData && dynamicFilesPresent
  }

  // Enhanced fetchProcessedData function
const fetchProcessedData = useCallback(async (payrollId, group, dataType = 'payroll') => {
  if (!payrollId || !group) {
    alert("Missing payroll ID or group")
    return
  }

  try {
    setLoadingTableData(true)
    const response = await axios.get(`${API_BASE}/ProcessData/${dataType}/${group}/${payrollId}`)
    
    // If called from data tab, update table data
    if (activeMainTab === 'data') {
      setTableData(response.data || [])
      setCurrentPage(1)
    }
    
    return response.data
  } catch (error) {
    console.error(`Error fetching ${dataType} data:`, error)
    
    // If called from data tab, clear table data
    if (activeMainTab === 'data') {
      setTableData([])
      if (error.response?.status === 404) {
        alert(`No ${dataType} data found for payroll: ${payrollId}`)
      } else {
        alert(`Error loading ${dataType} data: ${error.message}`)
      }
    }
    
    throw error
  } finally {
    if (activeMainTab === 'data') {
      setLoadingTableData(false)
    }
  }
}, [activeMainTab])

  // Function to fetch processed payroll data for calculations
  const fetchProcessedPayrollData = async (payrollId, group) => {
    try {
      const response = await axios.get(`${API_BASE}/ProcessData/payroll/${group}/${payrollId}`)
      return response.data
    } catch (error) {
      console.error("Error fetching processed payroll data:", error)
      throw error
    }
  }

  // Function to post calculated data record by record
  const postCalculatedData = async (record, calculationType, onProgress) => {
    try {
      // Create a copy of the record with the calculated obj type
      const calculatedRecord = {
        ...record,
        obj: calculationType, // Replace obj with calculated type (abonus, tevet, pension)
        id: 0 // Reset ID for new record
      }

      const response = await axios.post(`${API_BASE}/ProcessData/calculateddata`, calculatedRecord, {
        headers: { "Content-Type": "application/json" }
      })

      return response.data
    } catch (error) {
      console.error(`Error posting ${calculationType} data for employee ${record.employeeNo}:`, error)
      throw error
    }
  }

  // Function to process all calculated fields for a payroll
  const processCalculatedFields = async () => {
    if (!searchResult) {
      alert("Please select a payroll first")
      return
    }

    try {
      setCalculatedProcessing(true)
      setCalculatedProgress(0)
      setCalculatedCurrent(0)
      setCalculatedTotal(0)
      setCalculatedStatus("Initializing...")
      setCalculatedStartTime(new Date().toLocaleString())
      setCalculatedFinishTime("")
      setCalculatedErrors([])

      // Set status for calculated processing
      setCalculatedStatus("Fetching processed payroll data...")

      // Fetch the processed payroll data
      const payrollData = await fetchProcessedPayrollData(searchResult.payrollId, selectedGroup)
      
      if (!payrollData || payrollData.length === 0) {
        throw new Error("No processed payroll data found. Please upload and process files first.")
      }

      // Store the fetched data in IndexedDB for reference
      await storeInIndexedDB('processedPayrollData', `${searchResult.payrollId}_${selectedGroup}`, payrollData)

      const calculationTypes = ['abonus', 'tevet', 'pension']
      const totalRecords = payrollData.length * calculationTypes.length
      setCalculatedTotal(totalRecords)
      
      let processedCount = 0
      const errors = []

      // Process each calculation type
      for (const calculationType of calculationTypes) {
        setCalculatedStatus(`Processing ${calculationType.toUpperCase()} calculations...`)

        // Process each record for this calculation type
        for (let i = 0; i < payrollData.length; i++) {
          const record = payrollData[i]
          
          try {
            await postCalculatedData(record, calculationType)
            
            processedCount++
            setCalculatedCurrent(processedCount)
            
            const progress = Math.round((processedCount / totalRecords) * 100)
            setCalculatedProgress(progress)
            
            // Update status for current employee
            setCalculatedStatus(`Processing ${calculationType} for ${record.employeeName} (${i + 1}/${payrollData.length})`)

            // Small delay to prevent overwhelming the server
            await new Promise(resolve => setTimeout(resolve, 25))

          } catch (error) {
            const errorRecord = {
              employeeNo: record.employeeNo,
              employeeName: record.employeeName,
              calculationType: calculationType,
              error: error.message
            }
            errors.push(errorRecord)
            setCalculatedErrors(prev => [...prev, errorRecord])
          }
        }
      }

      setCalculatedStatus(errors.length === 0 
        ? "✅ All calculated fields processed successfully!" 
        : `⚠️ Processing completed with ${errors.length} errors`
      )
      
      setCalculatedFinishTime(new Date().toLocaleString())

      // Refresh file data status after processing
      await checkFileDataStatus(searchResult.payrollId, selectedGroup)
    } catch (error) {
      console.error('Error in processCalculatedFields:', error)
      setCalculatedStatus(`❌ Error: ${error.message}`)
      setCalculatedErrors(prev => [...prev, {
        employeeNo: "SYSTEM",
        employeeName: "System Error",
        calculationType: "ALL",
        error: error.message
      }])
    } finally {
      setCalculatedProcessing(false)
      if (!calculatedFinishTime) {
        setCalculatedFinishTime(new Date().toLocaleString())
      }
    }
  }

  // Enhanced IndexedDB storage function
  const storeInIndexedDB = async (storeName, key, data) => {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) {
        reject(new Error('IndexedDB not supported'))
        return
      }

      // First, open the database without specifying version to get current version
      const versionRequest = window.indexedDB.open('PayrollDB')
      
      versionRequest.onerror = () => {
        // If database doesn't exist, create it with version 1
        createDatabase(1)
      }
      
      versionRequest.onsuccess = () => {
        const db = versionRequest.result
        const currentVersion = db.version
        db.close()
        
        // Now open with the current version or upgrade if needed
        if (db.objectStoreNames.contains(storeName)) {
          // Store exists, use current version
          openAndStore(currentVersion)
        } else {
          // Store doesn't exist, upgrade to next version
          openAndStore(currentVersion + 1)
        }
      }
      
      versionRequest.onupgradeneeded = () => {
        // This shouldn't happen when opening without version, but handle it
        createDatabase(1)
      }
      
      function createDatabase(version) {
        const request = window.indexedDB.open('PayrollDB', version)
        
        request.onerror = () => reject(request.error)
        
        request.onupgradeneeded = (event) => {
          const db = event.target.result
          // Create all necessary object stores
          const storeNames = ['processedPayrollData', 'fileData', 'calculatedData', storeName]
          
          storeNames.forEach(name => {
            if (!db.objectStoreNames.contains(name)) {
              db.createObjectStore(name, { keyPath: 'id' })
            }
          })
        }
        
        request.onsuccess = () => {
          const db = request.result
          storeData(db)
        }
      }
      
      function openAndStore(version) {
        const request = window.indexedDB.open('PayrollDB', version)
        
        request.onerror = () => reject(request.error)
        
        request.onupgradeneeded = (event) => {
          const db = event.target.result
          if (!db.objectStoreNames.contains(storeName)) {
            db.createObjectStore(storeName, { keyPath: 'id' })
          }
        }
        
        request.onsuccess = () => {
          const db = request.result
          storeData(db)
        }
      }
      
      function storeData(db) {
        try {
          const transaction = db.transaction([storeName], 'readwrite')
          const store = transaction.objectStore(storeName)
          
          const putRequest = store.put({ id: key, data: data, timestamp: new Date().toISOString() })
          
          putRequest.onsuccess = () => {
            db.close()
            resolve()
          }
          putRequest.onerror = () => {
            db.close()
            reject(putRequest.error)
          }
        } catch (error) {
          db.close()
          reject(error)
        }
      }
    })
  }

  // Function to check if calculated fields processing is available
  const canProcessCalculatedFields = () => {
    if (!searchResult || !fileDataStatus) return false

    // Required files that must have data before calculated fields processing can start
    const requiredFiles = ['airtime', 'timesheet', 'masm', 'payroll', 'accrleave']

    // Check if ALL required files have data records > 0
    const allRequiredFilesHaveData = requiredFiles.every(fileName => {
      const hasData = fileDataStatus.filesWithData?.some(file =>
        file.dataFile === fileName && file.recordsCount > 0
      )
      console.log(`Calculated Fields - Checking ${fileName}: ${hasData}`)
      return hasData
    })

    console.log('Can process calculated fields:', allRequiredFilesHaveData)
    return allRequiredFilesHaveData
  }

  // Function to check if apportionment can be started
  const canStartApportionment = () => {
    if (!searchResult || !fileDataStatus) return false

    // Required input data files that must have data
    const requiredInputFiles = ['airtime', 'timesheet', 'masm', 'payroll', 'accrleave']

    // Required calculated fields that must have data (processed by calculated fields processing)
    const requiredCalculatedFiles = ['abonus', 'pension', 'tevet']

    // Check if ALL required input files have data records > 0
    const allInputFilesHaveData = requiredInputFiles.every(fileName => {
      const hasData = fileDataStatus.filesWithData?.some(file =>
        file.dataFile === fileName && file.recordsCount > 0
      )
      console.log(`Apportionment - Checking input file ${fileName}: ${hasData}`)
      return hasData
    })

    // Check if ALL required calculated fields have data records > 0
    const allCalculatedFieldsHaveData = requiredCalculatedFiles.every(fileName => {
      const hasData = fileDataStatus.filesWithData?.some(file =>
        file.dataFile === fileName && file.recordsCount > 0
      )
      console.log(`Apportionment - Checking calculated field ${fileName}: ${hasData}`)
      return hasData
    })

    console.log('All input files have data:', allInputFilesHaveData)
    console.log('All calculated fields have data:', allCalculatedFieldsHaveData)
    console.log('Can start apportionment:', allInputFilesHaveData && allCalculatedFieldsHaveData)

    return allInputFilesHaveData && allCalculatedFieldsHaveData
  }

  // Function to initiate apportionment
  const initiateApportionment = async () => {
    if (!searchResult?.payrollId || !selectedGroup) {
      alert("Please search for a payroll first")
      return
    }

    try {
      setApportionmentProcessing(true)
      setApportionmentStatus("Initiating apportionment...")
      setApportionmentStartTime(new Date().toLocaleString())
      setApportionmentFinishTime("")
      setApportionmentErrors([])

      // Initiate apportionment
      await axios.post(`${API_BASE}/Apportionments/${searchResult.payrollId}/${selectedGroup}`)

      // If no error occurred, consider it successful
      setApportionmentStatus("✅ Apportionment completed successfully!")
      setApportionmentFinishTime(new Date().toLocaleString())
      setApportionmentProcessing(false)

      // Refresh file data status after completion
      await checkFileDataStatus(searchResult.payrollId, selectedGroup)

    } catch (error) {
      console.error("Error initiating apportionment:", error)
      setApportionmentStatus(`❌ Error: ${error.message}`)
      setApportionmentErrors(prev => [...prev, {
        error: error.message,
        timestamp: new Date().toLocaleString()
      }])
      setApportionmentProcessing(false)
      setApportionmentFinishTime(new Date().toLocaleString())
    }
  }

  // Function to delete payroll
  const handleDeletePayroll = async () => {
    if (!searchResult?.payrollId || !selectedGroup) {
      alert("No payroll selected to delete")
      return
    }

    // Confirm deletion
    const confirmDelete = window.confirm(
      `Are you sure you want to delete payroll "${searchResult.payrollId}"?\n\n` +
      `This action cannot be undone and will permanently remove:\n` +
      `- Payroll data\n` +
      `- Associated files\n` +
      `- Processing history\n\n` +
      `Click OK to confirm deletion.`
    )

    if (!confirmDelete) {
      return
    }

    try {
      setDeleting(true)

      // Call the DELETE endpoint
      await axios.delete(`${API_BASE}/PayrollRuns/${searchResult.payrollId}/${selectedGroup}`)

      // Success - clear the search result and show success message
      setSearchResult(null)
      setFileDataStatus(null)
      setNotFound(false)

      alert(`Payroll "${searchResult.payrollId}" has been successfully deleted.`)

      // Optionally clear the form
      setSelectedYear("")
      setSelectedGroup("")
      setSelectedPeriod("")

    } catch (error) {
      console.error("Error deleting payroll:", error)

      if (error.response?.status === 404) {
        alert("Payroll not found. It may have already been deleted.")
      } else {
        alert(`Failed to delete payroll: ${error.message}`)
      }
    } finally {
      setDeleting(false)
    }
  }

  // Function to determine current workflow step
  const getCurrentWorkflowStep = () => {
    if (!searchResult || !fileDataStatus) return 1

    // Step 1: Upload All Files - Check if ALL required input files are uploaded
    const hasAllInputFiles = ['airtime', 'timesheet', 'masm', 'payroll', 'accrleave'].every(fileName => {
      return fileDataStatus.filesWithData?.some(file =>
        file.dataFile === fileName && file.recordsCount > 0
      )
    })

    if (!hasAllInputFiles) return 1

    // Step 2: Process Calculated Fields - Check if calculated fields exist
    const hasCalculatedFields = ['abonus', 'pension', 'tevet'].every(fileName => {
      return fileDataStatus.filesWithData?.some(file =>
        file.dataFile === fileName && file.recordsCount > 0
      )
    })

    if (!hasCalculatedFields) return 2

    // Step 3: Apportionment - All requirements met
    return 3
  }

  // Function to get step status
  const getStepStatus = (step) => {
    const currentWorkflowStep = getCurrentWorkflowStep()

    if (step < currentWorkflowStep) return 'completed'
    if (step === currentWorkflowStep) return 'current'
    return 'pending'
  }

  // Function to check if step is actionable
  const isStepActionable = (step) => {
    const currentWorkflowStep = getCurrentWorkflowStep()
    return step === currentWorkflowStep
  }

  // Auto-refresh data effect
  useEffect(() => {
    if (activeMainTab === 'data' && (searchResult || dataViewPayrollId)) {
      const interval = setInterval(() => {
        if (searchResult) {
          fetchProcessedData(searchResult.payrollId, selectedGroup)
        } else if (dataViewPayrollId && dataViewGroup) {
          fetchProcessedData(dataViewPayrollId, dataViewGroup)
        }
      }, 300000) // Refresh every 5 minutes
      
      return () => clearInterval(interval)
    }
  }, [searchResult, activeMainTab, dataViewPayrollId, dataViewGroup, selectedGroup, fetchProcessedData])

  const createPayroll = async () => {
    setShowCreatePayrollModal(false)
    await handleCreatePayroll()
  }

  // Add missing handleStartPensionProcessing function
  const handleStartPensionProcessing = async () => {
    if (!searchResult?.payrollId || !selectedGroup) {
      alert("Please search for a payroll first")
      return
    }

    try {
      setPensionProcessing(true)
      setPensionProgress(0)
      setPensionCurrent(0)
      setPensionTotal(0)
      setProcessingErrors([])
      setPensionStatus("Starting pension processing...")

      setOutputData(prev => [...prev, "Starting pension processing..."])
      
      // Simulate processing - replace with actual API calls
      const totalSteps = 100
      setPensionTotal(totalSteps)
      
      for (let i = 0; i <= totalSteps; i++) {
        setPensionCurrent(i)
        setPensionProgress((i / totalSteps) * 100)
        setPensionStatus(`Processing step ${i} of ${totalSteps}...`)
        
        // Small delay to show progress
        await new Promise(resolve => setTimeout(resolve, 50))
      }

      setPensionStatus("Pension processing completed successfully!")
      setOutputData(prev => [...prev, "✅ Pension processing completed successfully!"])

    } catch (error) {
      console.error("Error during pension processing:", error)
      setPensionStatus(`Error: ${error.message}`)
      setProcessingErrors(prev => [...prev, { 
        employeeNo: "SYSTEM", 
        employeeName: "System Error", 
        error: error.message 
      }])
    } finally {
      setPensionProcessing(false)
    }
  }

  // Sequential file upload function with error handling
  const handleProcessFiles = async () => {
    if (!searchResult) {
      alert("Please search for a payroll first")
      return
    }

    // Check if any files are selected for upload
    const hasFiles = fileUploads.payroll || fileUploads.timesheet ||
                     Object.values(dynamicUploads).some(file => file !== null)

    if (!hasFiles) {
      alert("Please select at least one file to upload")
      return
    }

    try {
      setProcessing(true)
      setOutputData([])
      setErrorData([])
      setStartTime(new Date().toLocaleString())

      setOutputData(prev => [...prev, "🚀 Starting file upload..."])

      // Step 1: Upload Payroll file first
      if (fileUploads.payroll) {
        setOutputData(prev => [...prev, "📄 Step 1: Uploading payroll file..."])
        try {
          const payrollResult = await processPayrollFile(fileUploads.payroll)
          if (payrollResult.errors && payrollResult.errors.length > 0) {
            throw new Error(`Payroll upload failed: ${payrollResult.errors.join(', ')}`)
          }
          setOutputData(prev => [...prev, "✅ Payroll file uploaded successfully"])
        } catch (error) {
          const errorMessage = `❌ Payroll upload failed: ${error.message}`
          setOutputData(prev => [...prev, errorMessage])
          setErrorData(prev => [...prev, {
            file: 'payroll',
            error: error.message,
            timestamp: new Date().toLocaleString()
          }])
          throw new Error(`Upload process aborted. ${errorMessage}`)
        }
      }

      // Step 2: Upload Timesheet file second
      if (fileUploads.timesheet) {
        setOutputData(prev => [...prev, "⏰ Step 2: Uploading timesheet file..."])
        try {
          const timesheetResult = await processTimesheetFile(fileUploads.timesheet)
          if (timesheetResult.errors && timesheetResult.errors.length > 0) {
            throw new Error(`Timesheet upload failed: ${timesheetResult.errors.join(', ')}`)
          }
          setOutputData(prev => [...prev, "✅ Timesheet file uploaded successfully"])
        } catch (error) {
          const errorMessage = `❌ Timesheet upload failed: ${error.message}`
          setOutputData(prev => [...prev, errorMessage])
          setErrorData(prev => [...prev, {
            file: 'timesheet',
            error: error.message,
            timestamp: new Date().toLocaleString()
          }])

          // Abort immediately on ANY timesheet error
          throw new Error(`Upload process aborted. ${errorMessage}`)
        }
      }

      // Step 3: Upload other files (airtime, masm, accrleave) simultaneously
      const otherFiles = dynamicFileTypes.filter(def =>
        ['airtime', 'masm', 'accrleave'].includes(def.dataName) && dynamicUploads[def.fields]
      )

      if (otherFiles.length > 0) {
        setOutputData(prev => [...prev, "📁 Step 3: Uploading remaining files simultaneously..."])

        try {
          const otherFilePromises = otherFiles.map(async (def) => {
            const file = dynamicUploads[def.fields]
            setOutputData(prev => [...prev, `📄 Uploading ${def.dataName} file...`])

            const result = await processDynamicFile(def, file)
            if (result.errors && result.errors.length > 0) {
              throw new Error(`${def.dataName} upload failed: ${result.errors.join(', ')}`)
            }
            setOutputData(prev => [...prev, `✅ ${def.dataName} file uploaded successfully`])
            return result
          })

          // Wait for all other files to complete simultaneously
          await Promise.all(otherFilePromises)
        } catch (error) {
          const errorMessage = `❌ Other files upload failed: ${error.message}`
          setOutputData(prev => [...prev, errorMessage])
          setErrorData(prev => [...prev, {
            file: 'other files',
            error: error.message,
            timestamp: new Date().toLocaleString()
          }])
          // Don't abort here - just log the error and continue
          setOutputData(prev => [...prev, "⚠️ Some files failed but continuing..."])
        }
      }

      setOutputData(prev => [...prev, "🎉 All files uploaded successfully!"])

      // Clear uploaded files only on complete success
      setFileUploads({ payroll: null, timesheet: null })
      setDynamicUploads({})

    } catch (error) {
      console.error('Error in handleProcessFiles:', error)
      setOutputData(prev => [...prev, `🛑 Upload process stopped: ${error.message}`])

      // Show detailed error information
      alert(`Upload Failed!\n\n${error.message}\n\nPlease check the error details and try again.`)
    } finally {
      setProcessing(false)
    }
  }

  // Handle employee selection for total calculation
  const handleEmployeeSelect = (employee) => {
    if (selectedEmployee && selectedEmployee.employeeNo === employee.employeeNo) {
      // Deselect if already selected
      setSelectedEmployee(null)
      setEmployeeTotal(0)
    } else {
      setSelectedEmployee(employee)

      // Get the total from our pre-calculated totals
      const total = employeeTotals[employee.employeeNo]?.total || 0
      setEmployeeTotal(total)
    }
  }

  // Helper function to determine if this is the last entry for an employee
  const isLastEmployeeEntry = (currentRow, allData) => {
    const employeeRows = allData.filter((row) => row.employeeNo === currentRow.employeeNo)
    const lastRow = employeeRows[employeeRows.length - 1]
    return lastRow.id === currentRow.id
  }

  // Filter & paginate data
  const filteredData = tableData.filter((r) =>
    [r.employeeNo, r.employeeName, r.benefit].join(" ").toLowerCase().includes(searchQuery.toLowerCase()),
  )
  const totalPages = Math.ceil(filteredData.length / itemsPerPage) || 1
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)

  // Generate pagination items
  const paginationItems = []
  for (let number = 1; number <= totalPages; number++) {
    if (number === 1 || number === totalPages || (number >= currentPage - 1 && number <= currentPage + 1)) {
      paginationItems.push(
        <Pagination.Item key={number} active={number === currentPage} onClick={() => setCurrentPage(number)}>
          {number}
        </Pagination.Item>,
      )
    } else if (
      (number === currentPage - 2 && currentPage > 3) ||
      (number === currentPage + 2 && currentPage < totalPages - 2)
    ) {
      paginationItems.push(<Pagination.Ellipsis key={`ellipsis-${number}`} />)
    }
  }

  return (
    <>
      <NavBar user={user} onLogout={onLogout} />
      <Container fluid>
    

      {/* Main Tab Navigation */}
      <Card className="shadow-sm mb-4 border-0">
      <Card.Header className="bg-white py-0 border-bottom-0 d-flex justify-content-between align-items-center">
          <Nav variant="tabs" activeKey={activeMainTab} onSelect={(k) => setActiveMainTab(k)} className="main-tabs">
            <Nav.Item>
              <Nav.Link eventKey="search" className="px-4 py-3">
                <i className="bi bi-search me-2"></i>
                Upload & Process
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="data" className="px-4 py-3">
                <i className="bi bi-table me-2"></i>
                Input Data
                {loadingTableData && <Spinner animation="border" size="sm" className="ms-2" />}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
           <Nav.Link
             eventKey="reports"
            className="px-4 py-3"
             disabled={!searchResult?.payrollId}
           >
                 <i className="bi bi-bar-chart me-2"></i>
                 Apportionments
                 {loadingReportData && <Spinner animation="border" size="sm" className="ms-2" />}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
         <Nav.Link
            eventKey="journals"
            className="px-4 py-3"
            disabled={!searchResult?.payrollId}          >
                 <i className="bi bi-bar-chart me-2"></i>
                 Journals
                 {loadingReportData && <Spinner animation="border" size="sm" className="ms-2" />}
              </Nav.Link>
            </Nav.Item>
            {outputData.length > 0 && (
              <Nav.Item>
                <Nav.Link eventKey="history" className="px-4 py-3">
                  <i className="bi bi-clock-history me-2"></i>
                  Processing History
                </Nav.Link>
              </Nav.Item>
            )}
          </Nav>
          <div className="pe-3">
      {/* Anything here will sit on the far right */}
       <Badge bg="primary" className="me-2 py-2 px-3">
                    <i className="bi bi-file-earmark-text me-1" />
                    Payroll ID: {searchResult?.payrollId || "None"}
                
                  </Badge>
    </div>
        </Card.Header>
      </Card>

      {/* Search & Process Tab */}
      {activeMainTab === "search" && (
        <>
          {/* Search Section - Compact Form */}
          <Card className="shadow-sm mb-4 border-0">
            <Card.Header className="bg-white border-bottom-0 py-3">
              <h5 className="mb-0 d-flex align-items-center">
                <i className="bi bi-search me-2"></i> Search Payroll
              </h5>
            </Card.Header>
            <Card.Body className="pt-0">
            {/* Replace your <Row> ... </Row> with this: */}
<div className="d-flex align-items-end flex-wrap gap-3 mb-3">
  {/* Year */}
  <Form.Group className="d-flex flex-column" style={{ minWidth: 120 }}>
    <Form.Label className="fw-bold text-secondary">Year</Form.Label>
    <Form.Select
      size="sm"
      value={selectedYear}
      onChange={e => setSelectedYear(e.target.value)}
      disabled={searching || processing}
    >
      <option value="">Select Year</option>
      {['2023','2024','2025'].map(y => (
        <option key={y} value={y}>{y}</option>
      ))}
    </Form.Select>
  </Form.Group>

  {/* Group */}
  <Form.Group className="d-flex flex-column" style={{ minWidth: 120 }}>
    <Form.Label className="fw-bold text-secondary">Group</Form.Label>
    <Form.Select
      size="sm"
      value={selectedGroup}
      onChange={e => setSelectedGroup(e.target.value)}
      disabled={searching || processing}
    >
      <option value="">Select Group</option>
      {['DCG','NCG'].map(g => (
        <option key={g} value={g}>{g}</option>
      ))}
    </Form.Select>
  </Form.Group>

  {/* Period */}
  <Form.Group className="d-flex flex-column" style={{ minWidth: 120 }}>
    <Form.Label className="fw-bold text-secondary">Period</Form.Label>
    <Form.Select
      size="sm"
      value={selectedPeriod}
      onChange={e => setSelectedPeriod(e.target.value)}
      disabled={searching || processing}
    >
      <option value="">Select Period</option>
      {['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'].map(p => (
        <option key={p} value={p}>{p}</option>
      ))}
    </Form.Select>
  </Form.Group>

  {/* Search Button */}
  <div className="align-self-end">
    <Button
      size="sm"
      variant="primary"
      onClick={handleSearch}
      disabled={searching || processing || !selectedYear || !selectedGroup || !selectedPeriod}
      className="me-2"
    >
      {searching
        ? <>
            <Spinner animation="border" size="sm" className="me-2" />
            Searching…
          </>
        : <>
            <i className="bi bi-search me-2" />
            Search
          </>}
    </Button>
  </div>

  {/* Delete Button - Show when payroll is found */}
  {searchResult && (
    <div className="align-self-end">
      <Button
        size="sm"
        variant="outline-danger"
        onClick={handleDeletePayroll}
        disabled={deleting || searching || processing || apportionmentProcessing}
      >
        {deleting
          ? <>
              <Spinner animation="border" size="sm" className="me-2" />
              Deleting…
            </>
          : <>
              <i className="bi bi-trash me-2" />
              Delete
            </>}
      </Button>
    </div>
  )}

  {/* Create Payroll (only when notFound) */}
  {notFound && (
    <div className="align-self-end">
      <Button
        size="sm"
        variant="outline-success"
        onClick={handleCreatePayroll}
        disabled={creating}
      >
        {creating
          ? <>
              <Spinner animation="border" size="sm" className="me-2" />
              Creating…
            </>
          : <>
              <i className="bi bi-plus-circle me-2" />
              Create Payroll
            </>}
      </Button>
    </div>
  )}
</div>


              {notFound && (
                <Alert variant="info" className="mb-0">
                  <i className="bi bi-info-circle me-2"></i>
                  No payroll found with ID: <strong>{getPayrollId()}</strong>. You can create a new payroll.
                </Alert>
              )}
            </Card.Body>
          </Card>

          {/* Payroll Details & Upload */}
          {searchResult && (
            <>
              {/* Payroll Details Card */}
              <Card className="shadow-sm mb-4 border-0">
                <Card.Header className="bg-white border-bottom-0 py-3">
                  <h5 className="mb-0 d-flex align-items-center">
                    <i className="bi bi-info-circle me-2"></i> Payroll Details
                    {checkingFileData && <Spinner animation="border" size="sm" className="ms-2" />}
                  </h5>
                </Card.Header>
                <Card.Body className="pt-0">
                  <Row className="g-3">
                    <Col md={2} sm={6}>
                      <div className="d-flex flex-column">
                        <span className="text-muted small">Payroll ID</span>
                        <span className="fw-medium">{searchResult.payrollId}</span>
                      </div>
                    </Col>
                    <Col md={2} sm={6}>
                      <div className="d-flex flex-column">
                        <span className="text-muted small">Period</span>
                        <span className="fw-medium">{`${selectedPeriod} ${selectedYear}`}</span>
                      </div>
                    </Col>
                    <Col md={3} sm={6}>
                      <div className="d-flex flex-column">
                        <span className="text-muted small">Status</span>
                        <Badge bg={searchResult.runStatus === "Completed" ? "success" : "warning"} className="w-auto">
                          {searchResult.runStatus}
                        </Badge>
                      </div>
                    </Col>
                    <Col md={2} sm={6}>
                      <div className="d-flex flex-column">
                        <span className="text-muted small">Date</span>
                        <span className="fw-medium">{searchResult.dateRun}</span>
                      </div>
                    </Col>
                    <Col md={3} sm={6}>
                      <div className="d-flex flex-column">
                        <span className="text-muted small">Run By</span>
                        <span className="fw-medium">{searchResult.runBy}</span>
                      </div>
                    </Col>
                  </Row>

                  {/* File Data Status Summary */}
                  {fileDataStatus && (
                    <div className="mt-4">
                      <h6 className="mb-2">File Data Status</h6>
                      <Row className="g-2">
                        {fileDataStatus.filesWithData?.map((file) => (
                          <Col key={file.dataFile} xs="auto">
                            <Badge bg="success" className="d-flex align-items-center">
                              <i className="bi bi-check-circle me-1"></i>
                              {file.dataFile}: {file.recordsCount} records
                            </Badge>
                          </Col>
                        ))}
                        {fileDataStatus.filesWithoutData?.filter(file => file.recordsCount === 0).map((file) => (
                          <Col key={file.dataFile} xs="auto">
                            <Badge bg="warning" className="d-flex align-items-center">
                              <i className="bi bi-exclamation-triangle me-1"></i>
                              {file.dataFile}: No data
                            </Badge>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  )}

                  {/* Workflow Stepper */}
                  <div className="mt-4">
                    <h6 className="mb-3">Payroll Processing Workflow</h6>

                    {/* Step 1: Upload All Required Files */}
                    <div className={`d-flex align-items-start mb-4 ${getStepStatus(1) === 'completed' ? 'text-success' : getStepStatus(1) === 'current' ? 'text-primary' : 'text-muted'}`}>
                      <div className="me-3 mt-1">
                        {getStepStatus(1) === 'completed' ? (
                          <i className="bi bi-check-circle-fill text-success"></i>
                        ) : getStepStatus(1) === 'current' ? (
                          <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center text-white" style={{width: '20px', height: '20px', fontSize: '12px'}}>1</div>
                        ) : (
                          <div className="bg-light border rounded-circle d-flex align-items-center justify-content-center text-muted" style={{width: '20px', height: '20px', fontSize: '12px'}}>1</div>
                        )}
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">Upload All Required Files</h6>
                        <small className="text-muted">Upload all 5 required files: payroll, timesheet, airtime, masm, and accrleave</small>

                        {/* Show completed status */}
                        {getStepStatus(1) === 'completed' && (
                          <div className="mt-2">
                            <div className="mb-2">
                              <Badge bg="success" className="me-1">Payroll: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'payroll')?.recordsCount || 0}</Badge>
                              <Badge bg="success" className="me-1">Timesheet: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'timesheet')?.recordsCount || 0}</Badge>
                              <Badge bg="success" className="me-1">Airtime: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'airtime')?.recordsCount || 0}</Badge>
                              <Badge bg="success" className="me-1">MASM: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'masm')?.recordsCount || 0}</Badge>
                              <Badge bg="success">Accrleave: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'accrleave')?.recordsCount || 0}</Badge>
                            </div>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => setActiveMainTab("history")}
                            >
                              <i className="bi bi-clock-history me-1"></i>
                              View Upload History
                            </Button>
                          </div>
                        )}

                        {/* Show history button for any step if files exist */}
                        {(getStepStatus(1) !== 'completed' && fileDataStatus?.filesWithData?.length > 0) && (
                          <div className="mt-2">
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() => setActiveMainTab("history")}
                            >
                              <i className="bi bi-clock-history me-1"></i>
                              View Upload History
                            </Button>
                          </div>
                        )}

                        {/* Show upload form for current step */}
                        {getStepStatus(1) === 'current' && (
                          <div className="mt-3 p-3 border rounded bg-light">
                            <Row className="g-3">
                              {/* Payroll File */}
                              <Col md={6}>
                                <Form.Group>
                                  <Form.Label>Payroll File <Badge bg="danger">Required</Badge></Form.Label>
                                  <Form.Control
                                    type="file"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={(e) => handleFileSelect('payroll', e)}
                                    disabled={processing}
                                    required
                                  />
                                  <div className="d-flex justify-content-between align-items-center mt-1">
                                    <small>Progress: {uploadProgress.payroll?.toFixed(0) || 0}%</small>
                                    <ProgressBar now={uploadProgress.payroll || 0} style={{ height: "6px", width: "50%" }} />
                                  </div>
                                </Form.Group>
                              </Col>

                              {/* Timesheet File */}
                              <Col md={6}>
                                <Form.Group>
                                  <Form.Label>Timesheet File <Badge bg="danger">Required</Badge></Form.Label>
                                  <Form.Control
                                    type="file"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={(e) => handleFileSelect('timesheet', e)}
                                    disabled={processing}
                                    required
                                  />
                                  <div className="d-flex justify-content-between align-items-center mt-1">
                                    <small>Progress: {uploadProgress.timesheet?.toFixed(0) || 0}%</small>
                                    <ProgressBar now={uploadProgress.timesheet || 0} style={{ height: "6px", width: "50%" }} />
                                  </div>
                                </Form.Group>
                              </Col>

                              {/* Dynamic Files: Airtime, MASM, Accrleave */}
                              {dynamicFileTypes
                                .filter(def => ['airtime', 'masm', 'accrleave'].includes(def.dataName))
                                .map((def) => (
                                <Col md={4} key={def.id}>
                                  <Form.Group>
                                    <Form.Label>{def.dataName.charAt(0).toUpperCase() + def.dataName.slice(1)} File <Badge bg="danger">Required</Badge></Form.Label>
                                    <Form.Control
                                      type="file"
                                      accept=".xlsx,.xls,.csv"
                                      onChange={(e) => handleDynamicFileSelect(def.fields, e)}
                                      disabled={processing}
                                      required
                                    />
                                    <div className="d-flex justify-content-between align-items-center mt-1">
                                      <small>Progress: {dynamicProgress[def.fields]?.toFixed(0) || 0}%</small>
                                      <ProgressBar
                                        now={dynamicProgress[def.fields] || 0}
                                        style={{ height: "6px", width: "50%" }}
                                      />
                                    </div>
                                  </Form.Group>
                                </Col>
                              ))}
                            </Row>

                            <div className="mt-3">
                              <Button
                                variant="primary"
                                onClick={async () => {
                                  await handleProcessFiles()
                                  await checkFileDataStatus(searchResult.payrollId, selectedGroup)
                                }}
                                disabled={processing || !fileUploads.payroll || !fileUploads.timesheet || !dynamicFileTypes.filter(def => ['airtime', 'masm', 'accrleave'].includes(def.dataName)).every(def => dynamicUploads[def.fields])}
                              >
                                {processing ? (
                                  <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Uploading Files...
                                  </>
                                ) : (
                                  <>
                                    <i className="bi bi-upload me-2" />
                                    Upload All Files
                                  </>
                                )}
                              </Button>

                              {/* Upload Progress Display */}
                              {processing && outputData.length > 0 && (
                                <div className="mt-3 p-3 border rounded bg-light">
                                  <h6 className="mb-2">
                                    <i className="bi bi-info-circle me-2"></i>
                                    Upload Progress
                                  </h6>
                                  <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                    {outputData.map((message, idx) => (
                                      <div key={idx} className="small mb-1">
                                        {message}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {/* Error Display */}
                              {errorData.length > 0 && (
                                <div className="mt-3 p-3 border border-danger rounded bg-danger bg-opacity-10">
                                  <h6 className="text-danger mb-2">
                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                    Upload Errors
                                  </h6>
                                  {errorData.map((error, idx) => (
                                    <div key={idx} className="text-danger small mb-2">
                                      <strong>{error.file}:</strong> {error.error}
                                      <div className="text-muted">
                                        <i className="bi bi-clock me-1"></i>
                                        {error.timestamp}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Step 2: Process Calculated Fields */}
                    <div className={`d-flex align-items-start mb-4 ${getStepStatus(2) === 'completed' ? 'text-success' : getStepStatus(2) === 'current' ? 'text-info' : 'text-muted'}`}>
                      <div className="me-3 mt-1">
                        {getStepStatus(2) === 'completed' ? (
                          <i className="bi bi-check-circle-fill text-success"></i>
                        ) : getStepStatus(2) === 'current' ? (
                          <div className="bg-info rounded-circle d-flex align-items-center justify-content-center text-white" style={{width: '20px', height: '20px', fontSize: '12px'}}>2</div>
                        ) : (
                          <div className="bg-light border rounded-circle d-flex align-items-center justify-content-center text-muted" style={{width: '20px', height: '20px', fontSize: '12px'}}>2</div>
                        )}
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">Process Calculated Fields</h6>
                        <small className="text-muted">Generate abonus, pension, and tevet calculations</small>

                        {/* Show completed status */}
                        {getStepStatus(2) === 'completed' && (
                          <div className="mt-2">
                            <Badge bg="success" className="me-1">Abonus: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'abonus')?.recordsCount || 0}</Badge>
                            <Badge bg="success" className="me-1">Pension: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'pension')?.recordsCount || 0}</Badge>
                            <Badge bg="success">Tevet: {fileDataStatus?.filesWithData?.find(f => f.dataFile === 'tevet')?.recordsCount || 0}</Badge>
                          </div>
                        )}

                        {/* Show action for current step */}
                        {isStepActionable(2) && (
                          <div className="mt-3 p-3 border rounded bg-info bg-opacity-10 border-info">
                            <p className="mb-3 text-muted">
                              <i className="bi bi-info-circle me-2"></i>
                              All required input files are uploaded. Click the button below to process calculated fields (abonus, pension, tevet).
                            </p>
                            <Button
                              variant="info"
                              onClick={processCalculatedFields}
                              disabled={calculatedProcessing}
                            >
                              {calculatedProcessing ? (
                                <>
                                  <Spinner animation="border" size="sm" className="me-2" />
                                  Processing Calculated Fields...
                                </>
                              ) : (
                                <>
                                  <i className="bi bi-calculator-fill me-2"></i>
                                  Process Calculated Fields
                                </>
                              )}
                            </Button>
                          </div>
                        )}

                        {/* Show processing progress when active */}
                        {calculatedProcessing && (
                          <div className="mt-3 p-3 border rounded bg-info bg-opacity-10 border-info">
                            <div className="d-flex align-items-center mb-2">
                              <Spinner animation="border" size="sm" className="me-2" />
                              <strong>Processing Calculated Fields...</strong>
                            </div>
                            <div className="mb-2">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span>{calculatedStatus}</span>
                                <span>{calculatedCurrent} / {calculatedTotal} records</span>
                              </div>
                              <ProgressBar
                                now={calculatedProgress}
                                variant="info"
                                className="mb-0"
                                style={{ height: "8px" }}
                              />
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">
                                <i className="bi bi-clock me-1"></i>
                                Started: {calculatedStartTime}
                              </small>
                              {calculatedFinishTime && (
                                <small className="text-muted">
                                  <i className="bi bi-clock-history me-1"></i>
                                  Finished: {calculatedFinishTime}
                                </small>
                              )}
                            </div>
                            {calculatedErrors.length > 0 && (
                              <div className="mt-2">
                                <small className="text-danger">
                                  <i className="bi bi-exclamation-triangle me-1"></i>
                                  {calculatedErrors.length} processing errors
                                </small>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Step 3: Apportionment */}
                    <div className={`d-flex align-items-start mb-4 ${getStepStatus(3) === 'completed' ? 'text-success' : getStepStatus(3) === 'current' ? 'text-warning' : 'text-muted'}`}>
                      <div className="me-3 mt-1">
                        {getStepStatus(3) === 'completed' ? (
                          <i className="bi bi-check-circle-fill text-success"></i>
                        ) : getStepStatus(3) === 'current' ? (
                          <div className="bg-warning rounded-circle d-flex align-items-center justify-content-center text-white" style={{width: '20px', height: '20px', fontSize: '12px'}}>3</div>
                        ) : (
                          <div className="bg-light border rounded-circle d-flex align-items-center justify-content-center text-muted" style={{width: '20px', height: '20px', fontSize: '12px'}}>3</div>
                        )}
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">Start Apportionment</h6>
                        <small className="text-muted">Final step - initiate the apportionment process</small>

                        {/* Show completed status */}
                        {getStepStatus(3) === 'completed' && (
                          <div className="mt-2">
                            <Badge bg="success">
                              <i className="bi bi-check-circle me-1"></i>
                              Apportionment completed successfully
                            </Badge>
                          </div>
                        )}

                        {/* Show action for current step */}
                        {isStepActionable(3) && (
                          <div className="mt-3 p-3 border rounded bg-warning bg-opacity-10 border-warning">
                            <p className="mb-3 text-muted">
                              <i className="bi bi-info-circle me-2"></i>
                              All files are uploaded and calculated fields are processed. Ready to start the final apportionment process.
                            </p>
                            <Button
                              variant="warning"
                              onClick={initiateApportionment}
                              disabled={apportionmentProcessing}
                            >
                              {apportionmentProcessing ? (
                                <>
                                  <Spinner animation="border" size="sm" className="me-2" />
                                  Processing Apportionment...
                                </>
                              ) : (
                                <>
                                  <i className="bi bi-pie-chart-fill me-2"></i>
                                  Start Apportionment
                                </>
                              )}
                            </Button>
                          </div>
                        )}

                        {/* Show processing status when active */}
                        {apportionmentProcessing && (
                          <div className="mt-3 p-3 border rounded bg-warning bg-opacity-10 border-warning">
                            <div className="d-flex align-items-center mb-2">
                              <Spinner animation="border" size="sm" className="me-2" />
                              <strong>Processing Apportionment...</strong>
                            </div>
                            <div className="mb-2">
                              <span>{apportionmentStatus}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                              <small className="text-muted">
                                <i className="bi bi-clock me-1"></i>
                                Started: {apportionmentStartTime}
                              </small>
                              {apportionmentFinishTime && (
                                <small className="text-muted">
                                  <i className="bi bi-clock-history me-1"></i>
                                  Finished: {apportionmentFinishTime}
                                </small>
                              )}
                            </div>
                            {apportionmentErrors.length > 0 && (
                              <div className="mt-2">
                                <small className="text-danger">
                                  <i className="bi bi-exclamation-triangle me-1"></i>
                                  {apportionmentErrors.length} processing errors
                                </small>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>





                  {/* Standalone Calculated Fields Button - Show when payroll/timesheet data exists but processing not available */}
                  {!canStartProcessing() && canProcessCalculatedFields() && !searchResult && (
                    <div className="mt-4">
                      <Alert variant="info" className="mb-3">
                        <i className="bi bi-info-circle me-2"></i>
                        This will fetch processed payroll data and generate calculated fields (abonus, tevet, pension).
                      </Alert>
                    </div>
                  )}
                </Card.Body>
              </Card>

              {/* Removed old upload form - now integrated into stepper */}
              {false && (
                <Card className="shadow-sm mb-4 border-0">
                  <Card.Header className="bg-white border-bottom-0 py-3">
                    <h5 className="mb-0 d-flex align-items-center">
                      <i className="bi bi-upload me-2"></i> Upload Files
                      <Badge bg="info" className="ms-2">
                        {!fileDataStatus ? "New Payroll" : "Missing Data"}
                      </Badge>
                    </h5>
                  </Card.Header>
                  <Card.Body className="pt-0">
                    {fileDataStatus && (
                      <Alert variant="info" className="mb-3">
                        <i className="bi bi-info-circle me-2"></i>
                        {fileDataStatus.filesWithData?.length > 0 
                          ? "Some files are missing data. Please upload the required files below."
                          : "No data found for this payroll. Please upload files to proceed."
                        }
                      </Alert>
                    )}

                    {/* Always show required files section when uploads are needed */}
                    <h6 className="mb-3 text-muted">Required Files</h6>
                    <Row className="g-3 mb-4">
                      {/* Payroll File */}
                      {(!fileDataStatus || 
                        !fileDataStatus.filesWithData?.some(file => file.dataFile === 'payroll' && file.recordsCount > 0)
                      ) && (
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="d-flex align-items-center">
                              Payroll File
                              {fileDataStatus && (
                                <Badge bg="warning" className="ms-2">Missing Data</Badge>
                              )}
                              {!fileDataStatus && (
                                <Badge bg="info" className="ms-2">Required</Badge>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="file"
                              accept=".xlsx,.xls,.csv"
                              onChange={(e) => handleFileSelect('payroll', e)}
                              disabled={processing}
                            />
                            
                            <div className="d-flex justify-content-between align-items-center mt-1">
                              <small>Progress: {uploadProgress.payroll?.toFixed(0) || 0}%</small>
                              <ProgressBar now={uploadProgress.payroll || 0} style={{ height: "6px", width: "50%" }} />
                            </div>
                          </Form.Group>
                        </Col>
                      )}

                      {/* Timesheet File */}
                      {(!fileDataStatus || 
                        !fileDataStatus.filesWithData?.some(file => file.dataFile === 'timesheet' && file.recordsCount > 0)
                      ) && (
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="d-flex align-items-center">
                              Timesheet File
                              {fileDataStatus && (
                                <Badge bg="warning" className="ms-2">Missing Data</Badge>
                              )}
                              {!fileDataStatus && (
                                <Badge bg="info" className="ms-2">Required</Badge>
                              )}
                            </Form.Label>
                            <Form.Control
                              type="file"
                              accept=".xlsx,.xls,.csv"
                              onChange={(e) => handleFileSelect('timesheet', e)}
                              disabled={processing}
                            />
                            
                            <div className="d-flex justify-content-between align-items-center mt-1">
                              <small>Progress: {uploadProgress.timesheet?.toFixed(0) || 0}%</small>
                              <ProgressBar now={uploadProgress.timesheet || 0} style={{ height: "6px", width: "50%" }} />
                            </div>
                          </Form.Group>
                        </Col>
                      )}
                    </Row>

                    {/* Dynamic Files - Only show if they don't have data */}
                    {(dynamicFileTypes.some(def => 
                      !fileDataStatus || 
                      !fileDataStatus.filesWithData?.some(file => 
                        file.dataFile === def.dataName && file.recordsCount > 0
                      )
                    )) && (
                      <>
                        <h6 className="mb-3 text-muted">Additional Files</h6>
                        {dynamicFileTypes.length === 0 ? (
                          <Alert variant="info">No additional file types available.</Alert>
                        ) : (
                          <Row className="g-3 mb-4">
                            {dynamicFileTypes
                              .filter(def => 
                                !fileDataStatus || 
                                !fileDataStatus.filesWithData?.some(file => 
                                  file.dataFile === def.dataName && file.recordsCount > 0
                                )
                              )
                              .map((def) => (
                              <Col md={6} key={def.id}>
                                <Form.Group>
                                  <Form.Label className="d-flex align-items-center">
                                    {def.dataName}
                                    {fileDataStatus && (
                                      <Badge bg="warning" className="ms-2">Missing Data</Badge>
                                    )}
                                    {!fileDataStatus && (
                                      <Badge bg="info" className="ms-2">Optional</Badge>
                                    )}
                                  </Form.Label>
                                  <Form.Control
                                    type="file"
                                    accept=".xlsx,.xls,.csv"
                                    onChange={(e) => handleDynamicFileSelect(def.fields, e)}
                                    disabled={processing}
                                  />
                                 
                                  <div className="d-flex justify-content-between align-items-center mt-1">
                                    <small>Progress: {dynamicProgress[def.fields]?.toFixed(0) || 0}%</small>
                                    <ProgressBar
                                      now={dynamicProgress[def.fields] || 0}
                                      style={{ height: "6px", width: "50%" }}
                                    />
                                  </div>
                                </Form.Group>
                              </Col>
                            ))}
                          </Row>
                        )}
                      </>
                    )}

                    {/* Action Buttons */}
                    <div className="mt-4">
                      <Button
                        variant="primary"
                        onClick={async () => {
                          await handleProcessFiles()
                          // Refresh file data status after processing
                          await checkFileDataStatus(searchResult.payrollId, selectedGroup)
                        }}
                        disabled={processing || !hasSelectedRequiredFiles()}
                        className="me-2"
                      >
                        {processing ? (
                          <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Uploading......
                          </>
                        ) : (
                          <>
                            <i className="bi bi-gear me-2" />
                            Upload Files
                          </>
                        )}
                      </Button>

                      {outputData.length > 0 && (
                        <Button variant="outline-secondary" onClick={() => setActiveMainTab("history")}>
                          <i className="bi bi-file-text me-2" />
                          View History
                        </Button>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              )}

              {/* Processing Progress */}
              {pensionProcessing && (
                <Card className="mt-4 border-0 shadow-sm">
                  <Card.Header className="bg-light py-3 border-bottom-0">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-calculator me-2"></i>
                      <span className="fw-medium">Data Processing</span>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div className="mb-3">
                      <div className="mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span>{pensionStatus}</span>
                          <span>
                            {pensionCurrent} / {pensionTotal} records
                          </span>
                        </div>
                        <ProgressBar
                          now={pensionProgress}
                          variant="success"
                          className="mb-0"
                          style={{ height: "10px" }}
                        />
                      </div>
                    </div>

                    {processingErrors.length > 0 && (
                      <div className="mt-3">
                        <h6 className="text-danger">Processing Errors ({processingErrors.length})</h6>
                        <div className="border rounded p-2 bg-light" style={{ maxHeight: "200px", overflowY: "auto" }}>
                          {processingErrors.map((err, idx) => (
                            <div key={idx} className="text-danger small mb-1">
                              <strong>
                                Employee {err.employeeNo} ({err.employeeName}):
                              </strong>{" "}
                              {err.error}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}

              {/* Calculated Fields Processing Progress - Now integrated into stepper */}
              {false && calculatedProcessing && (
                <Card className="mt-4 border-0 shadow-sm">
                  <Card.Header className="bg-light py-3 border-bottom-0">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-calculator-fill me-2"></i>
                      <span className="fw-medium">Calculated Fields Processing</span>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div className="mb-3">
                      <div className="mb-2">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span>{calculatedStatus}</span>
                          <span>
                            {calculatedCurrent} / {calculatedTotal} records
                          </span>
                        </div>
                        <ProgressBar
                          now={calculatedProgress}
                          variant="info"
                          className="mb-0"
                          style={{ height: "10px" }}
                        />
                      </div>
                      
                      {/* Timing Information */}
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        <small className="text-muted">
                          <i className="bi bi-clock me-1"></i>
                          Started: {calculatedStartTime}
                        </small>
                        {calculatedFinishTime && (
                          <small className="text-muted">
                            <i className="bi bi-clock-history me-1"></i>
                            Finished: {calculatedFinishTime}
                          </small>
                        )}
                      </div>
                    </div>

                    {calculatedErrors.length > 0 && (
                      <div className="mt-3">
                        <h6 className="text-danger">Processing Errors ({calculatedErrors.length})</h6>
                        <div className="border rounded p-2 bg-light" style={{ maxHeight: "200px", overflowY: "auto" }}>
                          {calculatedErrors.map((err, idx) => (
                            <div key={idx} className="text-danger small mb-1">
                              <strong>
                                Employee {err.employeeNo} ({err.employeeName}) - {err.calculationType}:
                              </strong>{" "}
                              {err.error}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}

              {/* Apportionment Processing Progress - Now integrated into stepper */}
              {false && apportionmentProcessing && (
                <Card className="mt-4 border-0 shadow-sm">
                  <Card.Header className="bg-light py-3 border-bottom-0">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-pie-chart-fill me-2"></i>
                      <span className="fw-medium">Apportionment Processing</span>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <div className="mb-3">
                      {/* Status Message */}
                      <div className="mb-3">
                        <h6 className="mb-2">{apportionmentStatus}</h6>
                      </div>

                      {/* Timing Information */}
                      <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted">
                          <i className="bi bi-clock me-1"></i>
                          Started: {apportionmentStartTime}
                        </small>
                        {apportionmentFinishTime && (
                          <small className="text-muted">
                            <i className="bi bi-clock-history me-1"></i>
                            Finished: {apportionmentFinishTime}
                          </small>
                        )}
                      </div>
                    </div>

                    {apportionmentErrors.length > 0 && (
                      <div className="mt-3">
                        <h6 className="text-danger">Processing Errors ({apportionmentErrors.length})</h6>
                        <div className="border rounded p-2 bg-light" style={{ maxHeight: "200px", overflowY: "auto" }}>
                          {apportionmentErrors.map((err, idx) => (
                            <div key={idx} className="text-danger small mb-1">
                              <strong>Error:</strong> {err.error}
                              {err.timestamp && (
                                <small className="text-muted d-block">
                                  <i className="bi bi-clock me-1"></i>
                                  {err.timestamp}
                                </small>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              )}
            </>
          )}
        </>
      )}

      {/* Data View Tab */}
      {activeMainTab === "data" && (
        <Card className="shadow-sm mb-4 border-0">
          <Card.Header className="bg-white border-bottom-0 py-3">
            <h5 className="mb-0 d-flex align-items-center">
              <i className="bi bi-table me-2"></i> Data View
            </h5>
          </Card.Header>
          <Card.Body className="pt-0">
            {/* File Type selector + Search */}
            <Row className="mb-3">
  <Col>
    <Form.Group className="position-relative" style={{ maxWidth: 300 }}>
      <Form.Select
        size="sm"
        value={dataViewType}
        onChange={e => setDataViewType(e.target.value)}
        disabled={loadingTableData}
      >
        <option value="payroll">Payroll</option>
        <option value="timesheet">Timesheet</option>
        <option value="airtime">Airtime</option>
        <option value="accrleave">Accrleave</option>
      </Form.Select>

      <Button
        size="sm"
        variant="primary"
        onClick={() => fetchProcessedData(searchResult.payrollId, selectedGroup, dataViewType)}
        disabled={loadingTableData || !searchResult}
        className="position-absolute end-0 bottom-0"
      >
        {loadingTableData ? (
          <>
            <Spinner animation="border" size="sm" className="me-2" />
            Loading…
          </>
        ) : (
          <>
            <i className="bi bi-search me-2" />
            Search
          </>
        )}
      </Button>
    </Form.Group>
  </Col>
</Row>


            {!searchResult && (
              <Alert variant="warning">
                Please first <strong>Search & Process</strong> a payroll.
              </Alert>
            )}

            {/* Selected employee total card */}
            {selectedEmployee && (
              <Alert variant="info" className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <strong>Selected Employee:</strong> {selectedEmployee.employeeName} ({selectedEmployee.employeeNo})
                </div>
                <div>
                  <strong>Total Amount:</strong> {employeeTotal.toLocaleString()}
                </div>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => {
                    setSelectedEmployee(null)
                    setEmployeeTotal(0)
                  }}
                >
                  Clear Selection
                </Button>
              </Alert>
            )}

            {/* Results */}
            {tableData.length === 0 ? (
              loadingTableData ? (
                <div className="text-center py-5">
                  <Spinner animation="border" />
                  <p className="mt-3">Loading data…</p>
                </div>
              ) : (
                <Alert variant="info">
                  No {dataViewType} records found for <strong>{searchResult?.payrollId}</strong>.
                </Alert>
              )
            ) : (
              <>
                {/* Export buttons and search */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <InputGroup className="w-50" style={{ maxWidth: 300 }}>
                    <InputGroup.Text>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search Employee No, Name, Benefit…"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value)
                        setCurrentPage(1)
                      }}
                    />
                  </InputGroup>
                  <div>
   
                  <DropdownButton
    id="export-dropdown"
    variant="outline-primary"
    title={
      <>
        <i className="bi bi-download me-1" />
        Export
      </>
    }
    size="sm"
    drop="up"
    align="end"
    disabled={filteredData.length === 0}
  >
    <Dropdown.Item
     onClick={() => {
      const rowsWithTotals = filteredData.map(r => ({
        ...r,
        total: isLastEmployeeEntry(r, filteredData)
          ? employeeTotals[r.employeeNo]?.total.toLocaleString()
          : "",
      }));
      exportToExcel({
        title: "Payroll_Data",
        id: searchResult?.payrollId || "export",
        rows: rowsWithTotals,
        headers: dataTabHeaders,
      });
    }}
    >
      <i className="bi bi-file-earmark-excel me-2" />
      Excel
    </Dropdown.Item>

    <Dropdown.Item
      onClick={() => {
        const rowsWithTotals = filteredData.map(r => ({
          ...r,
          total: isLastEmployeeEntry(r, filteredData)
            ? employeeTotals[r.employeeNo]?.total.toLocaleString()
            : "",
        }));
        exportToCSV({
          title: "Payroll_Data",
          id: searchResult?.payrollId || "export",
          rows: rowsWithTotals,
          headers: dataTabHeaders,
        });
      }}
    >
      <i className="bi bi-file-earmark-spreadsheet me-2" />
      CSV
    </Dropdown.Item>

    <Dropdown.Item
      onClick={() => {
        const rowsWithTotals = filteredData.map(r => ({
          ...r,
          total: isLastEmployeeEntry(r, filteredData)
            ? employeeTotals[r.employeeNo]?.total.toLocaleString()
            : "",
        }));
        exportToPDF({
          title: "Payroll_Data",
          id: searchResult?.payrollId || "export",
          rows: rowsWithTotals,
          headers: dataTabHeaders,
        });
      }}
    >
      <i className="bi bi-file-earmark-pdf me-2" />
      PDF
    </Dropdown.Item>
  </DropdownButton>
                    
                  </div>
                </div>

                <div style={{ maxHeight: "100vh", overflowY: "auto" }} className="border rounded">
                  <Table striped hover responsive className="mb-0">
                    <thead className="sticky-top bg-white">
                      <tr>
                        <th>Employee No</th>
                        <th>Name</th>
                        <th>Amount</th>
                        <th>Benefit</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((row, index) => {
                        const isLastEntry = isLastEmployeeEntry(row, filteredData)
                        const nextRow = index < paginatedData.length - 1 ? paginatedData[index + 1] : null
                        const isLastEmployeeRow = nextRow ? nextRow.employeeNo !== row.employeeNo : true

                        return (
                          <tr
                            key={row.id}
                            className={
                              selectedEmployee && selectedEmployee.employeeNo === row.employeeNo ? "table-primary" : ""
                            }
                            onClick={() => handleEmployeeSelect(row)}
                            style={{
                              cursor: "pointer",
                              borderBottom: isLastEmployeeRow ? "2px solid #dee2e6" : "",
                            }}
                          >
                            <td>{row.employeeNo}</td>
                            <td>{row.employeeName}</td>
                            <td>{typeof row.amount === "number" ? row.amount.toLocaleString() : row.amount}</td>
                            <td>{row.benefit}</td>
                            <td className={isLastEntry ? "fw-bold" : ""}>
                              {isLastEntry ? (
                                <>
                                  {employeeTotals[row.employeeNo]?.total.toLocaleString() || "0"}
                                  <small className="d-block text-muted">Total</small>
                                </>
                              ) : (
                                <>
                                  {/* {typeof row.amount === "number" ? row.amount.toLocaleString() : row.amount} */}
                                  <small className="d-block text-muted">-</small>

                                </>
                              )}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="small text-muted">
                    Showing {paginatedData.length} of {filteredData.length} entries
                  </div>
                  <Pagination>
                    <Pagination.Prev
                      onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                      disabled={currentPage === 1}
                    />
                    {paginationItems}
                    <Pagination.Next
                      onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}

      {/* Reports Tab */}
      {activeMainTab === "reports" && (
        <ReportsDashboard user={user} payrollId={searchResult.payrollId} group={searchResult.group} />
      )}
 {activeMainTab === "journals" && (
        <Journals user={user} payrollId={searchResult.payrollId} group={searchResult.group} />
      )}

      {/* Processing History Tab */}
      {activeMainTab === "history" && outputData.length > 0 && (
        <Card className="shadow-sm mb-4 border-0">
          <Card.Header className="bg-white d-flex justify-content-between align-items-center py-3">
            <h5 className="mb-0 d-flex align-items-center">
              <i className="bi bi-clock-history me-2"></i> Processing History
            </h5>
            <div>
              <Badge bg="light" text="dark" className="me-2">
                <i className="bi bi-clock me-1"></i> Start: {startTime}
              </Badge>
              <Badge bg="light" text="dark">
                <i className="bi bi-clock-history me-1"></i> End: {finishTime}
              </Badge>
            </div>
          </Card.Header>
          <Card.Body>
            <div style={{ maxHeight: "60vh", overflowY: "auto" }} className="border rounded p-3 bg-light">
              {outputData.map((line, idx) => (
                <div key={idx} className="py-1 small">
                  {line}
                </div>
              ))}
            </div>

            {errorData.length > 0 && (
              <div className="mt-4">
                <h6 className="text-danger mb-2">Processing Errors ({errorData.length})</h6>
                <div className="border rounded p-3 bg-light" style={{ maxHeight: "30vh", overflowY: "auto" }}>
                  {errorData.map((error, idx) => (
                    <div key={idx} className="py-1 small text-danger">
                      {error}
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="mt-3">
              <Button variant="outline-primary" onClick={() => setActiveMainTab("search")} className="me-2">
                <i className="bi bi-arrow-left me-1"></i> Back to Search
              </Button>
              <Button variant="outline-primary" onClick={() => setActiveMainTab("data")}>
                <i className="bi bi-table me-1"></i> Uploaded Data
              </Button>
            </div>
          </Card.Body>
        </Card>
      )}

      {/* Create Payroll Modal */}
      <Modal show={showCreatePayrollModal} onHide={() => setShowCreatePayrollModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Create New Payroll</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Payroll ID</Form.Label>
              <Form.Control
                type="text"
                value={newPayrollData.payrollId}
                onChange={(e) => setNewPayrollData({ ...newPayrollData, payrollId: e.target.value })}
                placeholder={getPayrollId()}
              />
              <Form.Text className="text-muted">Leave blank to use default: {getPayrollId()}</Form.Text>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                value={newPayrollData.description}
                onChange={(e) => setNewPayrollData({ ...newPayrollData, description: e.target.value })}
                placeholder={`Payroll for ${selectedGroup} - ${selectedPeriod} ${selectedYear}`}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Accounting String</Form.Label>
              <Form.Control
                type="text"
                value={newPayrollData.accountingString}
                onChange={(e) => setNewPayrollData({ ...newPayrollData, accountingString: e.target.value })}
                placeholder="Enter accounting string"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCreatePayrollModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={createPayroll}>
            Create Payroll
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Processed Data Modal */}
      <Modal show={showTableModal} onHide={() => setShowTableModal(false)} size="xl" centered>
        <Modal.Header closeButton className="border-bottom-0 pb-0">
          <Modal.Title>
            <div className="d-flex align-items-center">
              <i className="bi bi-table me-2"></i>
              Processed Payroll Data
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <InputGroup className="w-50">
              <InputGroup.Text>
                <i className="bi bi-search"></i>
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search by employee number, name, or benefit..."
                value={searchQuery}
                onChange={(e) => {
                  setSearchQuery(e.target.value)
                  setCurrentPage(1)
                }}
              />
            </InputGroup>
            {selectedEmployee && (
              <Alert variant="info" className="mb-0 ms-3">
                <strong>{selectedEmployee.employeeName}</strong> ({selectedEmployee.employeeNo}) - Total: <strong>${employeeTotal.toLocaleString()}</strong>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  className="ms-2"
                  onClick={() => {
                    setSelectedEmployee(null)
                    setEmployeeTotal(0)
                  }}
                >
                  Clear Selection
                </Button>
              </Alert>
            )}
          </div>

          <div style={{ maxHeight: "60vh", overflowY: "auto" }} className="border rounded">
            <Table striped hover responsive className="mb-0">
              <thead className="sticky-top bg-white">
                <tr>
                  <th>Employee No</th>
                  <th>Name</th>
                  <th>Amount</th>
                  <th>Benefit</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length === 0 ? (
                  <tr>
                    <td colSpan={5} className="text-center py-5">
                      <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                      No records found
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((row, index) => {
                    const isLastEntry = isLastEmployeeEntry(row, filteredData)
                    const nextRow = index < paginatedData.length - 1 ? paginatedData[index + 1] : null
                    const isLastEmployeeRow = nextRow ? nextRow.employeeNo !== row.employeeNo : true

                    return (
                      <tr
                        key={row.id}
                        className={
                          selectedEmployee && selectedEmployee.employeeNo === row.employeeNo ? "table-primary" : ""
                        }
                        onClick={() => handleEmployeeSelect(row)}
                        style={{
                          cursor: "pointer",
                          borderBottom: isLastEmployeeRow ? "2px solid #dee2e6" : "",
                        }}
                      >
                        <td>{row.employeeNo}</td>
                        <td>{row.employeeName}</td>
                        <td>{typeof row.amount === "number" ? row.amount.toLocaleString() : row.amount}</td>
                        <td>{row.benefit}</td>
                        <td className={isLastEntry ? "fw-bold" : ""}>
                          {isLastEntry ? (
                            <>
                              {employeeTotals[row.employeeNo]?.total.toLocaleString() || "0"}
                              <small className="d-block text-muted">Employee Total</small>
                            </>
                          ) : (
                            <>
                              {typeof row.amount === "number" ? row.amount.toLocaleString() : row.amount}
                              <small className="d-block text-muted">Sub Total</small>
                            </>
                          )}
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="small text-muted">
              Showing {paginatedData.length} of {filteredData.length} entries
            </div>
            <Pagination>
              <Pagination.Prev
                onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
              />
              {paginationItems}
              <Pagination.Next
                onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
              />
            </Pagination>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top-0">
          <Button variant="secondary" onClick={() => setShowTableModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Processing Complete Modal */}
      <Modal show={showProcessingCompleteModal} onHide={() => setShowProcessingCompleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Processing Complete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <i className="bi bi-check-circle-fill display-4 text-success mb-3"></i>
            <h5 className="mb-3">Data Processing Complete!</h5>
            
            <div className="row g-3 mb-4">
              <div className="col-6">
                <div className="card border-0 bg-light">
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-file-earmark-text fs-4 text-primary me-2"></i>
                      <div>
                        <div className="h6 mb-0">{processingResults.totalRecords}</div>
                        <small className="text-muted">Total Records</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="col-6">
                <div className="card border-0 bg-light">
                  <div className="card-body p-3">
                    <div className="d-flex align-items-center">
                      <i className="bi bi-check-circle fs-4 text-success me-2"></i>
                      <div>
                        <div className="h6 mb-0">{processingResults.processedRecords}</div>
                        <small className="text-muted">Processed</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {processingResults.processingTime && (
              <div className="mb-3">
                <small className="text-muted">
                  <i className="bi bi-clock me-1"></i>
                  Processing Time: {processingResults.processingTime}
                </small>
                <br />
                <small className="text-muted">
                  <i className="bi bi-calendar-check me-1"></i>
                  Completed At: {processingResults.completedAt}
                </small>
              </div>
            )}

            {processingResults.errors.length > 0 && (
              <Alert variant="warning" className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <i className="bi bi-exclamation-triangle me-2"></i>
                  <strong>Processing Errors ({processingResults.errors.length})</strong>
                </div>
                <div className="border rounded p-2 bg-light" style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {processingResults.errors.map((err, idx) => (
                    <div key={idx} className="text-danger small mb-1">
                      <strong>
                        Employee {err.employeeNo} ({err.employeeName}):
                      </strong>{" "}
                      {err.error}
                    </div>
                  ))}
                </div>
              </Alert>
            )}

            <div className="d-flex gap-2 justify-content-center">
            
              <Button 
                variant="primary" 
                onClick={() => setShowProcessingCompleteModal(false)}
                className="d-flex align-items-center"
              >
                <i className="bi bi-check-circle me-1"></i>
                Continue
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Container>
    </>
  )
}

export default PayrollPage
